"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var fabric_1 = require("fabric");
var Configurator = /** @class */ (function () {
    function Configurator() {
        this.configCanvasId = constants_1.CONFIGURATOR_CANVAS_ID;
        this.alignments = [
            'Gerade',
            'Gebogen unten, leicht',
            'Gebogen unten, mittel',
            'Gebogen unten, stark',
            'Gebogen oben, leicht',
            'Gebogen oben, mittel',
            'Gebogen oben, stark',
        ];
        this.fontsName = [
            'Roboto',
            'Open Sans',
            'Montserrat Alternates',
            'Source Sans Pro',
            'PT Sans',
            'Merriweather',
            'Lora',
            'Inconsolata',
            'Josefin Sans',
            'Bebas Neue',
            'Dosis',
            'Kanit',
            'Anton',
            'Pacifico',
            'Archivo Black',
            'Shadows Into Light',
            'Indie Flower',
            'Patrick Hand',
            'Caveat',
            'Satisfy',
            'PT Sans Caption',
            'Kalam',
            'Gloria Hallelujah',
            'Cuprum',
            'Cantarell',
            'Advent Pro',
            'Poiret One',
            'Julius Sans One',
            'Gruppo',
            'Fredericka the Great',
        ];
        this.fontsFileName = [
            'roboto-v30-latin-regular',
            'open-sans-v29-latin-regular',
            'montserrat-alternates-v17-latin-regular',
            'source-sans-pro-v21-latin-regular',
            'pt-sans-v17-latin-regular',
            'merriweather-v30-latin-regular',
            'lora-v24-latin-regular',
            'inconsolata-v30-latin-regular',
            'josefin-sans-v24-latin-regular',
            'bebas-neue-v9-latin-regular',
            'dosis-v26-latin-regular',
            'kanit-v12-latin-regular',
            'anton-v23-latin-regular',
            'pacifico-v22-latin-regular',
            'archivo-black-v17-latin-regular',
            'shadows-into-light-v15-latin-regular',
            'indie-flower-v17-latin-regular',
            'patrick-hand-v19-latin-regular',
            'caveat-v15-latin-regular',
            'satisfy-v17-latin-regular',
            'pt-sans-caption-v18-latin-regular',
            'kalam-v16-latin-regular',
            'gloria-hallelujah-v17-latin-regular',
            'cuprum-v19-latin-regular',
            'cantarell-v15-latin-regular',
            'advent-pro-v18-latin-regular',
            'poiret-one-v14-latin-regular',
            'julius-sans-one-v14-latin-regular',
            'gruppo-v16-latin-regular',
            'fredericka-the-great-v15-latin-regular',
        ];
        this.fonts = [];
        this.defaultFont = 'Roboto';
        this.fontSize = 32;
        this.fabricTextSvg = null;
        this.svgCounter = 0;
        this.textId = 'configText';
        this.textSvgId = 'svg';
        this.logoId = 'configLogo';
        this.backgroundId = 'configBackground';
        this.kindId = 'configKind';
        // private overlayImg: any;
        // private overlaySrc = '../../../typo3conf/ext/ww_project/Resources/Public/Images/svg/config-schwartau-logo.svg';
        this.glassSrcPath = '/typo3conf/ext/ww_project/Resources/Public/Images/configurator/glasses';
        this.glassSrcFileName = 'config-glass';
        this.glassSrcFileExtension = 'webp';
        this.uploadedImage = null;
        this.originalImageBase64 = '';
        this.fabricImageBaseConfig = {
            top: 0,
            left: 0,
            originX: 'left',
            originY: 'top',
            lockMovementX: false,
            lockMovementY: false,
            selectable: true,
        };
        this.configObjectControls = {
            borderColor: '#4C6E30',
            cornerSize: 9,
            cornerColor: '#FFFFFF',
            cornerStrokeColor: '#4C6E30',
            cornerStyle: 'circle',
            transparentCorners: false,
        };
        this.allowedFileTypes = [
            'image/jpeg',
            'image/png',
            'image/svg+xml',
        ];
    }
    Configurator.prototype.init = function () {
        var _this = this;
        this.body = document.body;
        this.configurator = this.body.querySelector("[".concat(constants_1.CONFIGURATOR, "]"));
        /**
         * if there's no configurator on the site return and do nothing
         */
        if (!this.configurator)
            return;
        this.header = this.body.querySelector("[".concat(constants_1.HEADER, "]"));
        this.footer = this.body.querySelector("[".concat(constants_1.FOOTER, "]"));
        this.configDesktop = this.configurator.querySelector("[".concat(constants_1.CONFIGURATOR_DESKTOP, "]"));
        this.configBlurred = this.configDesktop.querySelectorAll("[".concat(constants_1.CONFIGURATOR_BLURRED, "]"));
        this.configModal = this.configurator.querySelector("[".concat(constants_1.CONFIGURATOR_MODAL, "]"));
        this.configModalContent = this.configModal.querySelector("[".concat(constants_1.CONFIGURATOR_MODAL_CONTENT, "]"));
        this.configModalCloseButtons = this.configModal.querySelectorAll("[".concat(constants_1.CONFIGURATOR_MODAL_CLOSE, "]"));
        this.configTabLogo = this.configDesktop.querySelector("[".concat(constants_1.CONFIGURATOR_TAB_LOGO, "]"));
        this.configTabBackground = this.configDesktop.querySelector("[".concat(constants_1.CONFIGURATOR_TAB_BACKGROUND, "]"));
        this.configTabKind = this.configDesktop.querySelector("[".concat(constants_1.CONFIGURATOR_TAB_KIND, "]"));
        this.configTabText = this.configDesktop.querySelector("[".concat(constants_1.CONFIGURATOR_TAB_TEXT, "]"));
        this.configToolbar = this.configDesktop.querySelector("[".concat(constants_1.CONFIGURATOR_TOOLBAR, "]"));
        this.configToolbarLogo = this.configToolbar.querySelector("[".concat(constants_1.CONFIGURATOR_TOOLBAR_LOGO, "]"));
        this.configToolbarBackground = this.configToolbar.querySelector("[".concat(constants_1.CONFIGURATOR_TOOLBAR_BACKGROUND, "]"));
        this.configToolbarKind = this.configToolbar.querySelector("[".concat(constants_1.CONFIGURATOR_TOOLBAR_KIND, "]"));
        this.configToolbarText = this.configToolbar.querySelector("[".concat(constants_1.CONFIGURATOR_TOOLBAR_TEXT, "]"));
        this.configUploadLogo = this.configToolbarLogo.querySelector("[".concat(constants_1.CONFIGURATOR_UPLOAD_LOGO, "]"));
        this.configButtonsBackground = this.configToolbarBackground.querySelectorAll("[".concat(constants_1.CONFIGURATOR_BUTTON_BACKGROUND_IMAGE, "]"));
        this.configUploadBackground = this.configToolbarBackground.querySelector("[".concat(constants_1.CONFIGURATOR_UPLOAD_BACKGROUND, "]"));
        this.configButtonsKind = this.configToolbarKind.querySelectorAll("[".concat(constants_1.CONFIGURATOR_BUTTON_KIND_IMAGE, "]"));
        this.configTextarea = this.configToolbarText.querySelector("[".concat(constants_1.CONFIGURATOR_TEXTAREA, "]"));
        this.configColor = this.configToolbarText.querySelector("[".concat(constants_1.CONFIGURATOR_INPUT_COLOR, "]"));
        this.configFont = this.configToolbarText.querySelector("[".concat(constants_1.CONFIGURATOR_SELECT_FONT, "]"));
        this.configTextAlignment = this.configToolbarText.querySelector("[".concat(constants_1.CONFIGURATOR_SELECT_ALIGNMENT, "]"));
        this.configArtboard = this.configDesktop.querySelector("[".concat(constants_1.CONFIGURATOR_ARTBOARD, "]"));
        this.configArtboardToolButtons = this.configArtboard.querySelectorAll("[".concat(constants_1.CONFIGURATOR_ARTBOARD_TOOL_BUTTON, "]"));
        this.configAlignObjectHorizontal = this.configArtboard.querySelector("[".concat(constants_1.CONFIGURATOR_ALIGN_OBJECT_HORIZONTAL, "]"));
        this.configAlignObjectVertical = this.configArtboard.querySelector("[".concat(constants_1.CONFIGURATOR_ALIGN_OBJECT_VERTICAL, "]"));
        this.configDeleteObject = this.configArtboard.querySelector("[".concat(constants_1.CONFIGURATOR_DELETE_OBJECT, "]"));
        this.configReset = this.configArtboard.querySelector("[".concat(constants_1.CONFIGURATOR_RESET, "]"));
        this.configNotification = this.configArtboard.querySelector("[".concat(constants_1.CONFIGURATOR_NOTIFICATION, "]"));
        this.configNotificationText = this.configNotification.querySelector("[".concat(constants_1.CONFIGURATOR_NOTIFICATION_TEXT, "]"));
        this.configCanvas = this.configArtboard.querySelector("[".concat(constants_1.CONFIGURATOR_CANVAS, "]"));
        this.configGlass = this.configDesktop.querySelector("[".concat(constants_1.CONFIGURATOR_GLASS, "]"));
        this.configLabel = this.configDesktop.querySelector("[".concat(constants_1.CONFIGURATOR_LABEL, "]"));
        this.configLinksRefresh = this.configDesktop.querySelectorAll("[".concat(constants_1.CONFIGURATOR_LINK_REFRESH, "]"));
        this.configButtonOrder = this.configDesktop.querySelector("[".concat(constants_1.CONFIGURATOR_BUTTON_ORDER, "]"));
        this.configForm = this.configModalContent.querySelector("".concat(constants_1.CONFIGURATOR_FORM));
        this.configFormSuccess = this.configModalContent.querySelector("[".concat(constants_1.CONFIGURATOR_FORM_SUCCESS, "]"));
        this.configFormInputHidden = this.configModalContent.querySelector("".concat(constants_1.CONFIGURATOR_FORM_INPUT_HIDDEN));
        this.configModalReturn = this.configFormSuccess.querySelector("[".concat(constants_1.CONFIGURATOR_RETURN, "]"));
        this.configModalReturn.href = "".concat(this.configModalReturn.pathname, "#c").concat(this.configModalReturn.dataset.uid);
        this.changeToolbar();
        /**
         * create array of objects with font name and filepath
         */
        this.fontsName.forEach(function (font, index) {
            _this.fonts.push({
                name: font,
                woff: "../../../typo3conf/ext/ww_project/Resources/Public/Fonts/Configurator/".concat(_this.fontsFileName[index], ".woff"),
                woff2: "../../../typo3conf/ext/ww_project/Resources/Public/Fonts/Configurator/".concat(_this.fontsFileName[index], ".woff2"),
            });
        });
        this.createOptionsTextAlignment();
        this.createOptionsFont();
        this.configButtonOrder.addEventListener('click', function () {
            _this.openModal();
            if (_this.configFormInputHidden) {
                _this.configFormInputHidden.parentElement.parentElement.classList.add('d-none');
                _this.configFormInputHidden.value = _this.getConfiguratorBase64();
            }
        });
        this.configModal.addEventListener('click', function (event) {
            if (event.target === _this.configModal) {
                _this.closeModal();
            }
        });
        this.configModalCloseButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                _this.closeModal();
            });
        });
        this.configUploadLogo.addEventListener('change', function (e) {
            _this.handleUpload(e, _this.logoId);
        });
        this.configUploadLogo.addEventListener('click', function () {
            _this.configUploadLogo.value = '';
        });
        this.configUploadBackground.addEventListener('click', function () {
            _this.configUploadBackground.value = '';
        });
        this.configUploadBackground.addEventListener('change', function (e) {
            _this.handleUpload(e, _this.backgroundId);
        });
        this.configTextarea.addEventListener('input', function () {
            _this.changeText();
        });
        this.configColor.addEventListener('input', function () {
            _this.setFabricTextFillAndFont('fill', _this.configColor);
            _this.changeText();
        });
        this.configFont.addEventListener('change', function () {
            _this.configFont.style.fontFamily = _this.configFont.value.toString();
            _this.setFabricTextFillAndFont('fontFamily', _this.configFont);
            _this.changeText();
        });
        this.configTextAlignment.addEventListener('change', function () {
            _this.changeText();
        });
        /**
         * set rotate control to middle bottom
         */
        var objectControls = fabric_1.fabric.Object.prototype.controls;
        objectControls.mtr.y = 0.5;
        objectControls.mtr.offsetY = 32.5;
        /**
         * create Fabric Canvas
         */
        this.fabricCanvas = new fabric_1.fabric.Canvas(this.configCanvasId, {
            preserveObjectStacking: true,
            uniformScaling: true,
            perPixelTargetFind: true,
            targetFindTolerance: 8,
        });
        var width = this.configArtboard.offsetWidth;
        var height = this.configArtboard.offsetHeight;
        this.fabricCanvas.setWidth(width);
        this.fabricCanvas.setHeight(height);
        this.maxHeight = Math.round(this.fabricCanvas.height * 0.95);
        // this.createOverlayLogo();
        this.configArtboard.addEventListener('mouseup', function () {
            _this.toggleToolButtons();
        });
        /**
         * refresh preview for visible refresh button
         */
        this.configLinksRefresh.forEach(function (refreshLink) {
            if (window.getComputedStyle(refreshLink).display !== 'none') {
                refreshLink.addEventListener('click', function () {
                    _this.fabricCanvas.discardActiveObject().renderAll();
                    var src = _this.configGlass.src;
                    var srcStyled = _this.configGlass.dataset.srcStyled;
                    if (src !== srcStyled) {
                        _this.configGlass.src = srcStyled;
                    }
                    _this.configLabel.src = _this.getConfiguratorBase64();
                    _this.configLabel.parentElement.parentElement.classList.remove('d-none');
                });
            }
        });
        this.configAlignObjectHorizontal.addEventListener('click', function (e) {
            _this.artboardToolEvent(e, 'centerObjectH');
        });
        this.configAlignObjectVertical.addEventListener('click', function (e) {
            _this.artboardToolEvent(e, 'centerObjectV');
        });
        this.configDeleteObject.addEventListener('click', function (e) {
            _this.artboardToolEvent(e, 'remove');
            _this.toggleToolButtons();
        });
        // in discussion with client & graphic
        // this.configReset.addEventListener('click', (e) => {
        //   let objects = this.fabricCanvas.getObjects();
        //   objects = objects.filter(object => object.id !== this.overlayId);
        //   this.fabricCanvas.remove(...objects);
        //   this.toggleToolButtons();
        //   this.configLabel.src = '';
        //   this.configLabel.parentElement.classList.add('d-none');
        //   this.configGlass.src = this.configGlass.dataset.srcUnstyled;
        //   this.configButtonsBackground.forEach((button) => {
        //     button.classList.remove('active');
        //   });
        //   this.fabricTextSvg = null;
        //   this.configTextarea.value = '';
        //   this.configColor.value = '#2b3dca';
        // });
        this.configButtonsBackground.forEach(function (button) {
            button.addEventListener('click', function () {
                _this.configButtonsBackground.forEach(function (button) {
                    button.classList.remove('active');
                });
                button.classList.add('active');
                var backgroundFile = button.querySelector("[".concat(constants_1.CONFIGURATOR_BUTTON_BACKGROUND_IMAGE_FILE, "]"));
                _this.backgroundSrc = backgroundFile.src;
                var objects = _this.fabricCanvas.getObjects();
                if (objects.length > 0) {
                    objects.forEach(function (object) {
                        if (object.id === _this.backgroundId) {
                            _this.fabricCanvas.remove(object);
                        }
                    });
                }
                _this.handleBackground();
            });
        });
        this.configButtonsKind.forEach(function (button) {
            button.addEventListener('click', function () {
                _this.configButtonsKind.forEach(function (button) {
                    button.classList.remove('active');
                });
                button.classList.add('active');
                var kindFile = button.querySelector("[".concat(constants_1.CONFIGURATOR_BUTTON_KIND_IMAGE_FILE, "]"));
                _this.kindSrc = kindFile.src;
                _this.configGlass.dataset.srcStyled = "".concat(_this.glassSrcPath, "/").concat(_this.glassSrcFileName, "-").concat(button.dataset.kind, ".").concat(_this.glassSrcFileExtension);
                var objects = _this.fabricCanvas.getObjects();
                if (objects.length > 0) {
                    objects.forEach(function (object) {
                        if (object.id === _this.kindId) {
                            _this.fabricCanvas.remove(object);
                        }
                    });
                }
                _this.handleKind();
            });
        });
        this.showFormSuccess();
    };
    // createOverlayLogo() {
    //   fabric.Image.fromURL(this.overlaySrc, (img: any) => {
    //     this.fabricCanvas.add(img);
    //     img.scaleToWidth(Math.round((this.fabricCanvas.width - 8 * 16) * 3.2 / 30), false);
    //     // bug fix: splitting 'set' because otherwise overlay logo will not be displayed at export
    //     img.set({
    //       id: this.overlayId,
    //       selectable: false,
    //       hoverCursor: 'default',
    //       top: Math.round(this.fabricCanvas.height - 5.5 * 16 - img.scaleY * img.height),
    //     });
    //     this.fabricCanvas.centerObjectH(img);
    //     // bug fix: splitting 'set' because otherwise overlay logo will not be displayed at export
    //     img.set({
    //       left: Math.round(img.left),
    //     });
    //     this.fabricCanvas.bringToFront(img);
    //     this.overlayImg = img;
    //   });
    // }
    /**
     * create select options for every font family
     *
     * @returns void
     */
    Configurator.prototype.createOptionsFont = function () {
        var _this = this;
        this.fontsName.sort();
        this.fontsName.forEach(function (font) {
            var option = document.createElement('option');
            option.value = font;
            option.text = font;
            option.style.fontFamily = font + ', sans-serif';
            _this.configFont.add(option);
        });
    };
    /**
     * create select options for every text alignment
     *
     * @returns void
     */
    Configurator.prototype.createOptionsTextAlignment = function () {
        var _this = this;
        this.alignments.forEach(function (alignment) {
            var option = document.createElement('option');
            option.value = alignment;
            option.text = alignment;
            _this.configTextAlignment.add(option);
        });
    };
    /**
     * sets the active object inside the canvas
     * toggles the tool buttons (should be enabled when active object)
     *
     * @param {FabricObject} object
     */
    Configurator.prototype.setActiveObject = function (object) {
        this.fabricCanvas.setActiveObject(object);
        this.toggleToolButtons();
    };
    /**
     * triggers each tool (alignment and delete)
     *
     * @param {Event} e
     * @param {string} method
     *
     * @returns void
     */
    Configurator.prototype.artboardToolEvent = function (e, method) {
        e.preventDefault();
        var object = this.fabricCanvas.getActiveObject();
        if (object) {
            var oId = object.id;
            this.fabricCanvas[method](object);
            object.set({
                top: Math.round(object.top),
                left: Math.round(object.left),
            });
            if (method === 'remove') {
                if (oId === this.textId) {
                    this.configTextarea.value = '';
                    this.fabricText = null;
                }
                if (oId === this.logoId) {
                    this.configUploadLogo.value = '';
                }
                if (oId === this.kindId) {
                    this.configButtonsKind.forEach(function (button) {
                        button.classList.remove('active');
                    });
                    this.configGlass.dataset.srcStyled = "".concat(this.glassSrcPath, "/").concat(this.glassSrcFileName, "-strawberry.").concat(this.glassSrcFileExtension);
                }
                if (oId === this.backgroundId) {
                    this.configButtonsBackground.forEach(function (button) {
                        button.classList.remove('active');
                    });
                }
                if (oId === this.textSvgId) {
                    this.configTextarea.value = '';
                    this.fabricTextSvg = null;
                }
            }
        }
    };
    /**
     * switch toolbar for logo, background and text
     *
     * @returns void
     */
    Configurator.prototype.changeToolbar = function () {
        var buttonsArray = [this.configTabLogo, this.configTabBackground, this.configTabKind, this.configTabText];
        var toolsArray = [this.configToolbarLogo, this.configToolbarBackground, this.configToolbarKind, this.configToolbarText];
        buttonsArray.forEach(function (button, buttonIndex) {
            button.addEventListener('click', function () {
                buttonsArray.forEach(function (button) {
                    button.classList.remove('active');
                });
                button.classList.add('active');
                toolsArray.forEach(function (tool, toolIndex) {
                    tool.classList.add('d-none');
                    if (toolIndex === buttonIndex) {
                        tool.classList.remove('d-none');
                        return;
                    }
                });
            });
        });
    };
    /**
     * Disable and enable tool buttons (align and delete)
     *
     * @returns void
     */
    Configurator.prototype.toggleToolButtons = function () {
        if (this.fabricCanvas.getActiveObject()) {
            this.configArtboardToolButtons.forEach(function (button) {
                button.disabled = false;
            });
            return;
        }
        this.configArtboardToolButtons.forEach(function (button) {
            button.disabled = true;
        });
    };
    /**
     * Handle upload field
     *
     * @param {Event} changeEvent
     * @param {string} id
     *
     * @returns void
     */
    Configurator.prototype.handleUpload = function (changeEvent, id) {
        var _this = this;
        var reader = new FileReader();
        var target = changeEvent.target;
        var file = target.files[0];
        reader.readAsDataURL(file);
        this.hideNotification();
        if (!this.allowedFileTypes.includes(file.type)) {
            this.showNotification('Bilddatei nicht vom Typ *.jpg | *.png | *.svg');
            return;
        }
        reader.onload = function (onloadEvent) {
            var objects = _this.fabricCanvas.getObjects();
            var objectsLength = objects.length > 0;
            if (_this.uploadedImage && objectsLength) {
                objects.forEach(function (object) {
                    if (object.id === id) {
                        _this.fabricCanvas.remove(object);
                        return;
                    }
                });
            }
            if (id === _this.backgroundId) {
                _this.configButtonsBackground.forEach(function (button) {
                    button.classList.remove('active');
                });
                var objects_1 = _this.fabricCanvas.getObjects();
                var objectsLength_1 = objects_1.length > 0;
                if (objectsLength_1) {
                    _this.fabricCanvas.getObjects().forEach(function (object) {
                        if (object.id === _this.backgroundId) {
                            _this.fabricCanvas.remove(object);
                            object.setSrc(onloadEvent.target.result.toString(), function () {
                                object.scaleToHeight(_this.maxHeight, false);
                                _this.centerObject(object);
                            });
                            return;
                        }
                    });
                }
            }
            var targetResultString = onloadEvent.target.result.toString();
            var contentWithoutMime = targetResultString.split(',')[1];
            var sizeInMB = window.atob(contentWithoutMime).length / 1024 / 1024;
            if (sizeInMB > 2) {
                _this.showNotification('Bilddatei über 2 MB! Bitte verkleiner das Bild.');
                return;
            }
            var imgObj = new Image();
            _this.originalImageBase64 = targetResultString;
            imgObj.src = targetResultString;
            imgObj.onload = function () {
                var width = imgObj.width;
                var height = imgObj.height;
                if (width > 1000) {
                    _this.showNotification('Bildmaße zu breit! Bitte verkleiner das Bild.');
                    return;
                }
                if (width < 200) {
                    _this.showNotification('Bildmaße zu schmal! Bitte vergrößer das Bild.');
                    return;
                }
                if (height > 1000) {
                    _this.showNotification('Bildmaße zu hoch! Bitte verkleiner das Bild.');
                    return;
                }
                if (height < 200) {
                    _this.showNotification('Bildhöhe zu niedrig! Bitte vergrößer das Bild.');
                    return;
                }
                /**
                 * Create new image
                 */
                var options = { id: id };
                _this.uploadedImage = new fabric_1.fabric.Image(imgObj, options);
                _this.uploadedImage.set(_this.fabricImageBaseConfig);
                _this.uploadedImage.set(_this.configObjectControls);
                var imageHeight = _this.uploadedImage.scaleY * _this.uploadedImage.height;
                if (imageHeight > _this.maxHeight) {
                    _this.uploadedImage.scaleToHeight(_this.maxHeight, false);
                    _this.fabricCanvas.requestRenderAll();
                }
                _this.fabricCanvas.add(_this.uploadedImage);
                if (id === _this.logoId) {
                    var objects_2 = _this.fabricCanvas.getObjects();
                    objects_2.forEach(function (object) {
                        if (object.id === _this.textId || object.id === _this.textSvgId) {
                            _this.fabricCanvas.bringToFront(object);
                        }
                    });
                }
                if (id === _this.backgroundId) {
                    _this.uploadedImage.scaleToHeight(_this.maxHeight, false);
                    _this.fabricCanvas.sendToBack(_this.uploadedImage);
                }
                _this.centerObject(_this.uploadedImage);
                _this.setActiveObject(_this.uploadedImage);
                // this.fabricCanvas.bringToFront(this.overlayImg);
                _this.fabricCanvas.requestRenderAll();
            };
        };
    };
    /**
     * handle preset background images
     *
     * @returns void
     */
    Configurator.prototype.handleBackground = function () {
        var _this = this;
        this.hideNotification();
        fabric_1.fabric.Image.fromURL(this.backgroundSrc, function (imgObj) {
            imgObj.set('id', _this.backgroundId);
            imgObj.set(_this.fabricImageBaseConfig);
            imgObj.set(_this.configObjectControls);
            imgObj.scaleToHeight(_this.maxHeight, false);
            _this.fabricCanvas.add(imgObj);
            _this.centerObject(imgObj);
            _this.fabricCanvas.sendToBack(imgObj);
            _this.setActiveObject(imgObj);
            _this.fabricCanvas.requestRenderAll();
        });
    };
    /**
     * handle preset kind images
     *
     * @returns void
     */
    Configurator.prototype.handleKind = function () {
        var _this = this;
        this.hideNotification();
        fabric_1.fabric.Image.fromURL(this.kindSrc, function (imgObj) {
            imgObj.set('id', _this.kindId);
            imgObj.set(_this.fabricImageBaseConfig);
            imgObj.set(_this.configObjectControls);
            imgObj.scaleToHeight(Math.round(_this.maxHeight / 6), false);
            _this.fabricCanvas.add(imgObj);
            _this.centerObject(imgObj);
            // this.fabricCanvas.sendToBack(imgObj);
            _this.setActiveObject(imgObj);
            _this.fabricCanvas.requestRenderAll();
        });
    };
    /**
     * show error notification
     *
     * @param {string} text
     *
     * @returns void
     */
    Configurator.prototype.showNotification = function (text) {
        this.configNotification.classList.remove('d-none');
        this.configNotificationText.innerText = text;
    };
    /**
     * hide error notification
     *
     * @returns void
     */
    Configurator.prototype.hideNotification = function () {
        this.configNotification.classList.add('d-none');
    };
    /**
     * centersobject on the canvas
     *
     * @param {FabricObject} object
     *
     * @returns void
     */
    Configurator.prototype.centerObject = function (object) {
        this.fabricCanvas.centerObject(object);
        object.set({
            top: Math.round(object.top),
            left: Math.round(object.left),
        });
        this.fabricCanvas.requestRenderAll();
    };
    /**
     * opens the modal
     *
     * @returns void
     */
    Configurator.prototype.openModal = function () {
        this.configModal.classList.add('fade-in');
        this.configModalContent.scrollTop = 0;
        this.body.style.overflow = 'hidden';
        // fix blur for firefox
        if (navigator.userAgent.search('Firefox') > -1) {
            this.header.classList.add('blurred');
            this.footer.classList.add('blurred');
            this.configBlurred.forEach(function (element) {
                element.classList.add('blurred');
            });
        }
    };
    /**
     * closes the modal
     *
     * @returns void
     */
    Configurator.prototype.closeModal = function () {
        var _this = this;
        this.configModal.classList.remove('fade-in');
        this.configModal.classList.add('fade-out');
        var modalCss = window.getComputedStyle(this.configModal);
        var delay = modalCss.animationDelay.replace('s', '');
        var duration = modalCss.animationDuration.replace('s', '');
        var nDelay = Number(delay) * 1000;
        var nDuration = Number(duration) * 1000;
        var timeout = nDelay + nDuration;
        setTimeout(function () {
            _this.configModal.classList.remove('fade-out');
        }, timeout);
        setTimeout(function () {
            _this.body.style.overflow = 'auto';
        }, nDelay);
        // fix blur for firefox
        if (navigator.userAgent.search('Firefox') > -1) {
            setTimeout(function () {
                _this.header.classList.remove('blurred');
                _this.footer.classList.remove('blurred');
                _this.configBlurred.forEach(function (element) {
                    element.classList.remove('blurred');
                });
            }, nDelay);
        }
    };
    /**
     * changes text inside canvas
     *
     * @returns void
     */
    Configurator.prototype.changeText = function () {
        if (this.configTextarea.value === '') {
            this.fabricCanvas.remove(this.fabricText);
            this.fabricCanvas.remove(this.fabricTextSvg);
            this.fabricText = null;
            this.fabricTextSvg = null;
            return;
        }
        if (this.configTextAlignment.value === this.alignments[0]) {
            this.fabricCanvas.remove(this.fabricTextSvg);
            this.fabricTextSvg = null;
            this.setConfigText();
            return;
        }
        this.changeTextAlignment();
    };
    /**
     * create text for canvas
     *
     * @returns void
     */
    Configurator.prototype.setConfigText = function () {
        var value = this.configTextarea.value;
        var textObjects = this.fabricCanvas.getObjects('text');
        var exists = false;
        if (textObjects.length > 0) {
            exists = true;
        }
        if (!exists) {
            var options = {
                id: this.textId,
                top: 10,
                left: 10,
                text: value,
                fill: this.configColor.value,
                fontFamily: this.configFont.value ? this.configFont.value : this.defaultFont,
                fontSize: this.fontSize,
            };
            this.fabricText = new fabric_1.fabric.Text(value, options);
            this.fabricText.set(this.configObjectControls);
            this.fabricCanvas.add(this.fabricText);
            this.fabricCanvas.bringToFront(this.fabricText);
            // this.fabricCanvas.bringToFront(this.overlayImg);
            this.centerObject(this.fabricText);
            this.setActiveObject(this.fabricText);
        }
        else if (this.fabricText.text != value) {
            this.fabricText.set('text', value);
            this.fabricCanvas.bringToFront(this.fabricText);
        }
    };
    /**
     * changes text alignment and font family
     *
     * @returns void
     */
    Configurator.prototype.changeTextAlignment = function () {
        var _this = this;
        if (this.configTextarea.value) {
            this.fabricCanvas.getObjects().forEach(function (object) {
                if (object.id === _this.textId || object.id === _this.textSvgId) {
                    _this.fabricCanvas.remove(object);
                    return;
                }
            });
            var configFont_1 = this.configFont.value ? this.configFont.value.toString() : this.defaultFont;
            this.fonts.forEach(function (font) {
                var fontName = font.name;
                if (fontName === configFont_1) {
                    var pathWoff = font.woff;
                    var pathWoff2 = font.woff2;
                    Promise.all([_this.getPromise(pathWoff), _this.getPromise(pathWoff2)])
                        .then(function (data) {
                        var defs = _this.setSvgDefs(data, fontName);
                        var svgDataURI = _this.setSvg(defs);
                        _this.setTextImage(svgDataURI);
                        _this.fabricCanvas.requestRenderAll();
                    }, function (error) {
                        console.error(error);
                    });
                    return;
                }
            });
        }
    };
    /**
     * create image on the canvas for curved text
     *
     * @param {string} svgDataURI
     *
     * @returns void
     */
    Configurator.prototype.setTextImage = function (svgDataURI) {
        var _this = this;
        fabric_1.fabric.Image.fromURL(svgDataURI, function (img) {
            img.set({
                id: _this.textSvgId,
            });
            img.set(_this.configObjectControls);
            _this.fabricCanvas.add(img);
            _this.centerObject(img);
            _this.setActiveObject(img);
            _this.fabricCanvas.bringToFront(img);
            // this.fabricCanvas.bringToFront(this.overlayImg);
            _this.fabricCanvas.requestRenderAll();
            _this.fabricTextSvg = img;
        });
    };
    /**
     * get font file as data url from texts font family
     * needs to be data url to embed in svg
     *
     * @param {string} path
     * @returns {Promise<string>}
     */
    Configurator.prototype.getPromise = function (path) {
        return new Promise(function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.open('GET', path, true);
            request.onreadystatechange = function () {
                if (request.readyState === 4) {
                    if (request.status === 200 || request.status === 0) {
                        var reader = new FileReader();
                        reader.readAsDataURL(request.response);
                        reader.onload = function (e) {
                            resolve(e.target.result.toString());
                        };
                        reader.onerror = function (error) {
                            reject(error);
                        };
                    }
                    else {
                        reject(request.status);
                    }
                }
            };
            request.responseType = 'blob';
            request.send();
        });
    };
    /**
     * set defs for svg with embed font family
     *
     * @param {Awaited<string>[]} data
     * @param {string} fontName
     *
     * @returns {SVGDefsElement} defs
     */
    Configurator.prototype.setSvgDefs = function (data, fontName) {
        var fontFace = "@font-face {\n                          font-family: ".concat(fontName, ";\n                          font-style: normal;\n                          font-weight: 400;\n                          src: local(''),\n                          url(").concat(data[0], ") format('woff'),\n                          url(").concat(data[1], ") format('woff2');\n                        }");
        var defs = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
        var style = document.createElementNS('http://www.w3.org/2000/svg', 'style');
        style.innerHTML = fontFace;
        defs.appendChild(style);
        return defs;
    };
    /**
     * creates svg
     * and includes defs into svg
     *
     * @param {SVGDefsElement} defs
     *
     * @returns {string}
     */
    Configurator.prototype.setSvg = function (defs) {
        var span = document.createElement('span');
        span.style.fontSize = this.fontSize + 'px';
        span.style.fontFamily = this.configFont.value ? this.configFont.value.toString() : this.defaultFont;
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        var text = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        var textPath = document.createElementNS('http://www.w3.org/2000/svg', 'textPath');
        span.innerHTML = this.configTextarea.value.trim();
        document.body.appendChild(span);
        var spanWidth = span.offsetWidth;
        document.body.removeChild(span);
        var width = Math.round(spanWidth + 2 * this.fontSize);
        var triangleX = Math.round((width / 2 - this.fontSize) / 2);
        var height = Math.round(spanWidth / 4 + 2 * this.fontSize);
        var startEndY = Math.round(height - this.fontSize / 2);
        var pathValue;
        var triangleHeight;
        var value = this.configTextAlignment.value;
        if (value) {
            if (value === this.alignments[1] || value === this.alignments[4]) {
                triangleHeight = Math.round((height - this.fontSize) / 4);
            }
            if (value === this.alignments[2] || value === this.alignments[5]) {
                triangleHeight = Math.round((height - this.fontSize) / 2.25);
            }
            if (value === this.alignments[3] || value === this.alignments[6]) {
                triangleHeight = Math.round((height - this.fontSize) / 1.5);
            }
            pathValue = "M".concat(this.fontSize, " ").concat(startEndY, " C").concat(this.fontSize + triangleX, " ").concat(startEndY - triangleHeight, ", ").concat(width - this.fontSize - triangleX, " ").concat(startEndY - triangleHeight, ", ").concat(width - this.fontSize, " ").concat(startEndY);
            if (value === this.alignments[1] || value === this.alignments[2] || value === this.alignments[3]) {
                var triangleY = Math.round(triangleHeight + this.fontSize / 2);
                startEndY = height - startEndY;
                pathValue = "M".concat(this.fontSize, " ").concat(startEndY, " C").concat(this.fontSize + triangleX, " ").concat(triangleY, ", ").concat(width - this.fontSize - triangleX, " ").concat(triangleY, ", ").concat(width - this.fontSize, " ").concat(startEndY);
                textPath.setAttribute('dominant-baseline', 'hanging');
            }
        }
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svg.setAttribute('encoding', 'UTF-8');
        svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
        svg.setAttribute('width', width.toString());
        svg.setAttribute('height', height.toString());
        path.setAttribute('d', pathValue);
        path.setAttribute('id', "curve".concat(this.svgCounter));
        path.setAttribute('fill', 'transparent');
        text.setAttribute('width', width.toString());
        text.setAttribute('fill', this.configColor.value);
        text.setAttribute('font-size', "".concat(this.fontSize, "px"));
        text.setAttribute('startOffset', '50%');
        text.setAttribute('text-anchor', 'middle');
        textPath.setAttribute('href', "#curve".concat(this.svgCounter++));
        textPath.setAttribute('startOffset', '50%');
        textPath.setAttribute('text-anchor', 'middle');
        textPath.setAttribute('font-family', this.configFont.value ? this.configFont.value.toString() : this.defaultFont);
        textPath.innerHTML = this.configTextarea.value;
        text.appendChild(textPath);
        svg.appendChild(defs);
        svg.appendChild(path);
        svg.appendChild(text);
        var svgString = new XMLSerializer().serializeToString(svg);
        var encodedData = encodeURIComponent(svgString);
        return "data:image/svg+xml;utf8,".concat(encodedData);
    };
    /**
     * creates base64 url from canvas
     *
     * @returns {string} base64
     */
    Configurator.prototype.getConfiguratorBase64 = function () {
        var inset = 4 * 16;
        var radius = 30;
        var bleed = 2;
        var bleedRatio = bleed / radius;
        var trimWidth = this.fabricCanvas.width - 2 * inset;
        var trimHeight = this.fabricCanvas.height - 2 * inset;
        var cropTop = inset - bleedRatio * trimHeight;
        var cropLeft = inset - bleedRatio * trimWidth;
        var labelWidth = (2 * bleed + radius) / radius * trimWidth;
        var labelHeight = (2 * bleed + radius) / radius * trimHeight;
        var base64 = this.fabricCanvas.toDataURL({
            format: 'png',
            multiplier: 1.5,
            top: cropTop,
            left: cropLeft,
            width: labelWidth,
            height: labelHeight,
        });
        return base64;
    };
    /**
     * handle form submit on success
     *
     * @returns void
     */
    Configurator.prototype.showFormSuccess = function () {
        var _this = this;
        var url = window.location.search;
        var action = encodeURIComponent('[action]');
        var controller = encodeURIComponent('[controller]');
        var performConfigurator = url.includes("".concat(action, "=perform")) && url.includes("".concat(controller, "=Configurator"));
        if (performConfigurator) {
            this.configurator.scrollIntoView();
            // setTimeout so it happens after scroll has ended
            setTimeout(function () {
                _this.openModal();
            }, 1000);
            if (!this.configForm) {
                this.configFormSuccess.classList.remove('d-none');
                return;
            }
            this.configForm.classList.add('is-validated');
        }
    };
    /**
     * sets and changes text color and font family
     *
     * @param {string} method
     * @param {HTMLInputElement | HTMLSelectElement} input
     */
    Configurator.prototype.setFabricTextFillAndFont = function (method, input) {
        if (this.fabricText && this.fabricText[method] !== input.value) {
            this.fabricText.set(method, input.value);
            this.fabricCanvas.requestRenderAll();
        }
    };
    return Configurator;
}());
exports.default = Configurator;
